import { EntityProfilePlaceholderTab } from '@features/Shared/EntityProfile/EntityProfilePlaceholderTab'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslations } from '@utils/i18n-to-migrate'

export const Route = createFileRoute('/framework/forestowner/$forestownerId/fsc')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'FSC',
  },
})

function RouteComponent() {
  const { t } = useTranslations()
  return (
    <EntityProfilePlaceholderTab
      title={t('forestowner-search-overview.tabs.fsc')}
      description={t('framework-forestownersandbox.placeholderDescription')}
    />
  )
}
